// initial state
import { sendRequest } from '../../../api/reconciliation'

const state = {
  currentProfile: null,
  email: '',
  dateStart: new Date(),
  dateEnd: new Date(),
  error: ''
}

// getters
const getters = {
  currentProfile: state => state.currentProfile,
  email: state => state.email,
  dateStart: state => state.dateStart,
  dateEnd: state => state.dateEnd
}

// actions
const actions = {
  async send ({state}) {
    try {
      await sendRequest({
        currentProfile: state.currentProfile,
        email: state.email,
        dateStart: state.dateStart,
        dateEnd: state.dateEnd
      })
    } catch (e) {
      state.error = e.response.data.error
    }
  }
}

// mutations
const mutations = {
  setCurrentProfile (state, {currentProfile}) {
    state.currentProfile = currentProfile
  },
  setEmail (state, {email}) {
    state.email = email
  },
  setDateStart (state, {dateStart}) {
    state.dateStart = dateStart
  },
  setDateEnd (state, {dateEnd}) {
    state.dateEnd = dateEnd
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/components/store/modules/reconciliation.js